
import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell } from "recharts";

// Consistent color scheme
const COLORS = ['#0072BC', '#004880', '#34C759', '#FF3B30', '#FFCC00', '#5856D6', '#FF9500'];

interface ThematicCluster {
  name: string;
  value: number;
  percentage: number;
}

interface ThematicClusteringProps {
  thematicClustering: ThematicCluster[];
}

const ThematicClustering: React.FC<ThematicClusteringProps> = ({ thematicClustering }) => {
  return (
    <section className="space-y-4">
      <h2 className="text-xl font-semibold">5. 📂 Thematische clustering</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Clustering per thema</CardTitle>
            <CardDescription>Verdeling van schadegevallen per thema</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="h-80">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={thematicClustering}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis 
                    dataKey="name" 
                    tickFormatter={(value) => {
                      if (value.length > 10) {
                        return `${value.substring(0, 10)}...`;
                      }
                      return value;
                    }}
                  />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="value" name="Aantal" fill="#0072BC">
                    {thematicClustering.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Thematische gegevens in detail</CardTitle>
            <CardDescription>Tabel met percentages</CardDescription>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Thema</TableHead>
                  <TableHead className="text-right">Aantal</TableHead>
                  <TableHead className="text-right">Percentage</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {thematicClustering.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell className="text-right">{item.value}</TableCell>
                    <TableCell className="text-right">{item.percentage}%</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            
            <div className="mt-4">
              <h3 className="font-medium mb-2">Feiten:</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Transport + vergeten leveringen verklaren 45% van alle gevallen</li>
                <li>Kleurproblemen vallen op ondanks relatief lager volume</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ThematicClustering;
